module.exports = __webpack_public_path__ + "img/fondo3_betterfield.9c86c4f3.jpg";